// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"U5-z","vrsnlCrossSiteLabel":"V5-z"};